import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loaded: false,
  list: [],
};

const WizardAlertsSlice = createSlice({
  name: "WizardAlerts",
  initialState,
  reducers: {
    recieveWizardAlerts(state, action) {
      state.list = action.payload;
      state.loaded = true;
    },
    // Optimistic: the bar and the sidebar badge both drop on the click rather
    // than a round trip later. They read the same list, so they stay in step.
    removeWizardAlertLocal(state, action) {
      state.list = state.list.filter((a) => a.wizard_id !== action.payload);
    },
  },
});

export const { recieveWizardAlerts, removeWizardAlertLocal } =
  WizardAlertsSlice.actions;

export default WizardAlertsSlice.reducer;
